module.exports = __webpack_public_path__ + "static/media/fpGuideMx.0cd80296.png";